
import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { IconComponent } from '@libs/components/icons';
import { CustomerModel } from '@libs/account/models';

@Component({
  selector: 'ui-customer-details',
  templateUrl: './customer-details.component.html',
  styleUrls: ['./customer-details.component.scss'],
  imports: [
    IconComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerDetailsComponent {
  public readonly customer: InputSignal<CustomerModel> = input.required<CustomerModel>();
}
